import { useEffect, useState } from 'react'

import { ConnectWebSocket, GetActiveStadiumZones, GetGenderMode, SaveUserZone, ValidateNumberZone } from './../../utilities/BL/Zones'


const Zones = ({ onZoneSaved }) => {
    const [selectedZone, setSelectedZone] = useState(0)
    const [errorMessage, setErrorMessage] = useState('')
    const [disabledButton, setDisabledButton] = useState(true)

    const [womensModeActive,setWomensModeActive] = useState(false)
    const [isWorking,setIsWorking] = useState(false)
    
    // NUEVO ESTADO PARA ZONAS DINÁMICAS
    const [dynamicZones, setDynamicZones] = useState([])

    const ChangeListValue = async (e) => {
        setErrorMessage('')
        setSelectedZone(0)
        const option = parseInt(e.target.value)
        if (option > 0) {
            setDisabledButton(false)
            setSelectedZone(option)
        } else {
            setDisabledButton(true)
        }
    }

    const SaveZone = async () => {
        try {
            setIsWorking(true)
            setErrorMessage('')
            if (selectedZone === 0) return setErrorMessage('Selecciona tu zona')

            // Buscamos la zona seleccionada en nuestra lista dinámica
            const selectedZoneData = dynamicZones.find(z => z.id === selectedZone);
            if (!selectedZoneData) return setErrorMessage('Zona no válida');

            // Guardamos usando el nombre "real/interno" que el backend espera (Ej. "azul")
            const response = await SaveUserZone(selectedZoneData.internalName)
            if (!response.success) return setErrorMessage(response.message)

            await ConnectWebSocket(response.data.text)
            onZoneSaved()
        } catch (error) {
            setErrorMessage('Ocurrió un error al guardar la zona')
        } finally {
            setIsWorking(false)
        }
    }

    const LoadPage = async () => {
        try {
            // NUEVO: Consultar al servidor las zonas activas
            const zonesRes = await GetActiveStadiumZones();
            if (zonesRes.success && zonesRes.data.length > 0) {
                setDynamicZones(zonesRes.data);
            } else {
                // FALLBACK: Si falla el servidor, pones tus zonas de emergencia aquí
                setDynamicZones([
                    { id: 1, displayName: "Juanjolote Local", internalName: "zona1" },
                    { id: 2, displayName: "Juanjolote Visita", internalName: "zona2" }
                ]);
            }
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <div className="Zones">
            <div className="Zones__ListContainer">
                <label className="Zones__ListContainer__Label" htmlFor="sZone">Selecciona tu zona:</label>
                <select id="sZone" className="Zones__ListContainer__List" name="zone" value={selectedZone} onChange={(e) => ChangeListValue(e)}>
                    <option value={0}>Selecciona una zona</option>
                    
                    {/* RENDERIZADO DINÁMICO */}
                    {dynamicZones.map(zone => (
                        <option key={zone.id} value={zone.id}>
                            {zone.displayName}
                        </option>
                    ))}
                </select>

                {disabledButton ? (
                    <p className="Btn__Adsl--Disabled Zones__ListContainer__Button">Guardar</p>
                ) : (
                    isWorking ? (
                        <button className="Btn__Adsl--Disabled Zones__ListContainer__Button">Guardando...</button>
                    ) : (
                        <>
                            <button className="Btn__Adsl--Red Zones__ListContainer__Button" onClick={SaveZone}>Guardar</button>
                            {errorMessage && <p className="Zones__ListContainer__Error">{errorMessage}</p>}
                        </>
                    )
                )}
            </div>
        </div>
    )
}

export { Zones };